(function ($, SelectBox, site) {
  Drupal.behaviors.power_night_filter_v1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $thismodule = $('.js-power-night__filter', context);

      $thismodule.each(function () {
        var $module = $(this);
        var $filter = $module.find('.js-power-night__filter-select');
        var $sentence = $module.find('.power-night__filter-sentence');
        var $defaultContentBlock = $module.closest('.power-night_v1').find('.power-night__default');
        var $stayingContentBlock = $module.closest('.power-night_v1').find('.power-night__in');
        var $goingContentBlock = $module.closest('.power-night_v1').find('.power-night__out');
        var $defaultContentHeader = $module.find('.power-night__header-default');
        var $stayingContentHeader = $module.find('.power-night__header-in');
        var $goingContentHeader = $module.find('.power-night__header-out');
        var $parent = $module.closest('.js-power-night-v1');
        var minWidth = 180;
        var factor = 9.45;
        var longest = 0;
        var setWidth;

        function getUrlParam(name) {
          var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

          if (results === null) {
            return null;
          }

          return decodeURI(results[1]) || 0;
        }

        function setDropdownWidth(selectElement) {
          selectElement.find('option').slice(1).each(function () {
            if ($(this).text().length > longest) {
              longest = $(this).text().length;
            }
          });
          setWidth = Math.round(longest * factor);
          if (setWidth < minWidth) {
            selectElement.css('min-width', minWidth);
          } else {
            selectElement.css('min-width', setWidth);
          }
        }

        function setupSelect() {
          var theWidth = $filter.css('min-width');

          new SelectBox($filter, {
            mobile: true
          });

          // Need to set to match the placeholder dropdown width.
          $filter.siblings('a.selectBox.selectBox-dropdown').css('min-width', theWidth);
          setUpClickListeners();
        }

        function generateSelectElementOptions(selectElement, func) {
          var naturalLangVal = $filter.data('options-order');
          var subtagVal = $filter.data('subtags-order');
          var parsedNaturalLangVal;
          var parsedSubtagVal;

          if (naturalLangVal && subtagVal) {
            parsedNaturalLangVal = naturalLangVal.match(/[^[\]]+/g);
            parsedSubtagVal = subtagVal.match(/[^[\]]+/g);
            if (parsedNaturalLangVal.length === parsedSubtagVal.length) {
              $.each(parsedNaturalLangVal, function (index, val) {
                var _option = '<option value="' + parsedSubtagVal[index].replace(/ /g, '_').toLowerCase() + '">' + val + '</option>';

                selectElement.append(_option);
              });
              setDropdownWidth(selectElement);
              func();
            }
          }
        }

        /* Engagement analytics */
        function fireAnalytic(eventAction, eventLabel) {
          site.track.evtLink({
            event_name: 'elOwnTheNight',
            event_category: 'own the night',
            event_action: eventAction,
            event_label: eventLabel
          });
        }

        function setUpClickListeners() {
          // We need to attach the click listeners to the select options after the user
          // clicks the sentence since on document ready they are not available (they get
          // generated by the SelectBox library afterwards)
          $sentence.once().on('click', function () {
            var $generatedSelectOptions = $('ul.power-night__filter-select-selectBox-dropdown-menu li a');

            $generatedSelectOptions.click(function () {
              if (!$generatedSelectOptions.index(this)) {
                toggleContentVisibility('default');
                fireAnalytic('Filter-Default', 'click');
              } else {
                var selection = $(this).attr('rel');

                fireAnalytic('Filter-' + selection, 'click');
                toggleContentVisibility(selection);
                $parent.trigger('boutique:filter_initiated');
              }
            });
            $(this).off();
          });
        }

        function toggleContentVisibility(blockId) {
          var selector, selectorHeader;

          $defaultContentBlock.fadeOut();
          $stayingContentBlock.fadeOut();
          $goingContentBlock.fadeOut();
          $defaultContentHeader.fadeOut();
          $stayingContentHeader.fadeOut();
          $goingContentHeader.fadeOut();
          selector = '.power-night__' + blockId;
          selectorHeader = '.power-night__header-' + blockId;
          $(selector + ', ' + selectorHeader).delay(400).fadeIn();
        }

        generateSelectElementOptions($filter, setupSelect);
        if (window.location.hash) {
          toggleContentVisibility(window.location.hash.substring(1));
          $filter.val(window.location.hash.substring(1));
        }
        var param_inspo = getUrlParam('inspo');

        if (param_inspo) {
          toggleContentVisibility(param_inspo);
          $filter.val(param_inspo);
        }
      });
    }
  };
})(jQuery, SelectBox, site);
